const processesTabs = document.querySelectorAll('[data-process-name]');
const processesTabsContent = document.querySelectorAll('[data-process-content]');

function showTabContent(tab) {
    const tabNumber = tab.getAttribute('data-process-name');

    processesTabs.forEach(item => {
        item.classList.remove('active');
    });
    tab.classList.add('active');

    processesTabsContent.forEach(item => {
        item.classList.remove('active');
    });
    document.querySelector(`[data-process-content="${tabNumber}"]`).classList.add('active');
}

processesTabs.forEach(tab => {
    tab.addEventListener("click", () => {
        showTabContent(tab);
    })
})